import { render, staticRenderFns } from "./CheckboxTable.vue?vue&type=template&id=49e9b884&scoped=true"
import script from "./CheckboxTable.vue?vue&type=script&lang=js"
export * from "./CheckboxTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e9b884",
  null
  
)

export default component.exports